export default "__VITE_ASSET__r0wtvw0b__"